import { usStatesList } from 'Constants/usStatesList'

import { CityAndStateAbbr } from './getCityAndStateAbbr.types'

export const getCityAndStateAbbr = (city?: string | null): CityAndStateAbbr => {
  if (!city) {
    return {
      city: '',
      stateAbbr: '',
    }
  }

  const commaIdx = city.lastIndexOf(',')
  const citySubstr = city.substring(0, commaIdx)
  const stateSubstr = city.substring(commaIdx + 2)
  const stateListItem = usStatesList.find(
    stateItem =>
      stateItem.name === stateSubstr || stateItem.abbr === stateSubstr,
  )

  if (!stateListItem) {
    return {
      city,
      stateAbbr: '',
    }
  }

  return {
    city: citySubstr,
    stateAbbr: stateListItem.abbr,
  }
}
